/* global window */

// Did not work as desired....
import './featured_products.scss';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');
	const { trackImpressionsEvent } = require('public/js/lib/adobe-dtm-helper');

	$onReady({rp$, window,
		label: 'featured_products',
		fn: function () {
			let $featured_products_slider, timeout_val, $featured_product;

			$featured_product = rp$('.featured-product');
			if ($featured_product) {
				// Track Adobe DTM featured product impression
				trackImpressionsEvent();
			}

			$featured_products_slider = rp$('.featured-products-slider');

			if($featured_products_slider) {
				timeout_val = $featured_products_slider.data('timeout');
				if (!timeout_val) {
					timeout_val = 4000;
				}

				// attach owl carousel if in carousel mode
				$featured_products_slider.find('ul').addClass('owl-carousel').owlCarousel({
					autoplay: false,
					autoplayTimeout: timeout_val,
					loop: true,
					dots: true,
					lazyLoad: true,
					nav: true,
					items: 1,
				});
			}
		},
	});
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
